jQuery(document).ready(function ($)
{
	const $btn     = $( '[data-mobile-btn]' );
	const $mobMenu = $( '[data-mobile-menu]' );
	const $header  = $( '[data-header]' );
	const $body    = $( 'body' );

	// Toggle mobile menu
	$btn.on( 'click', () => {
		$btn.toggleClass( 'js-active' );
		$mobMenu.toggleClass( 'js-active' );
		$header.toggleClass( 'js-active' );
		$body.toggleClass( 'js-mobile-menu-open' );
	});

	// Toggle submenu accordions
	const $hasDropdown = $( '[data-mob-link]' );

	$hasDropdown.on( 'click', ( event ) => {
		event.preventDefault();

		const $clickedItem    = $( event.currentTarget );
		const $targetSelector = $clickedItem.attr( 'data-mob-link' );
		const $targetSection  = $( `[data-mob-section="${$targetSelector}"]` );

		$clickedItem.toggleClass( 'js-active' );
		$targetSection.toggleClass( 'js-active' );
	});
});
